import _defineProperty from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { genStyleHooks, mergeToken } from '../../theme/internal';
// ============================== Shared ==============================
var genSharedEmptyStyle = function genSharedEmptyStyle(token) {
  var componentCls = token.componentCls,
    margin = token.margin,
    marginXS = token.marginXS,
    marginXL = token.marginXL,
    fontSize = token.fontSize,
    lineHeight = token.lineHeight;
  return _defineProperty({}, componentCls, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    marginInline: marginXS,
    fontSize: fontSize,
    lineHeight: lineHeight,
    textAlign: 'center'
  }, "".concat(componentCls, "-image"), {
    height: token.emptyImgHeight,
    marginBottom: marginXS,
    opacity: token.opacityImage,
    img: {
      height: '100%'
    },
    svg: {
      maxWidth: '100%',
      height: '100%',
      margin: 'auto'
    }
  }), "".concat(componentCls, "-description"), {
    color: token.colorTextDescription
  }), "".concat(componentCls, "-footer"), {
    marginTop: margin
  }), '&-normal', _defineProperty(_defineProperty({
    marginBlock: marginXL,
    color: token.colorTextDescription
  }, "".concat(componentCls, "-description"), {
    color: token.colorTextDescription
  }), "".concat(componentCls, "-image"), {
    height: token.emptyImgHeightMD
  })), '&-small', _defineProperty({
    marginBlock: marginXS,
    color: token.colorTextDescription
  }, "".concat(componentCls, "-image"), {
    height: token.emptyImgHeightSM
  })));
};
// ============================== Export ==============================
export default genStyleHooks('Empty', function (token) {
  var componentCls = token.componentCls,
    controlHeightLG = token.controlHeightLG,
    calc = token.calc;
  var emptyToken = mergeToken(token, {
    emptyImgCls: "".concat(componentCls, "-img"),
    emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
    emptyImgHeightMD: controlHeightLG,
    emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
  });
  return [genSharedEmptyStyle(emptyToken)];
});